import { getCurrentYear } from '@web/helpers/getCurrentYear'
const currentYear = getCurrentYear()

export const localization = {
  en: {
    allright: `© ${currentYear} CHOC. All right reserved.`,
    termsOfUse: 'Terms of Use',
    privacyPolicy: 'Privacy Policy',
    and: 'and'
  },
  es: {
    allright: `© ${currentYear} CHOC. Todos los derechos reservados.`,
    termsOfUse: 'Términos de uso',
    privacyPolicy: 'política de privacidad',
    and: 'y'
  },
  keyMapping: {
    termsOfUse: 'UFD_Auth_Footer_Terms_of_Use',
    privacyPolicy: 'UFD_Privacy_Policy_Button',
    and: 'UFD_Auth_Footer_And_Text'
  }
}
